import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

export const getCustomersRatingReviewAPI = (search:any,page:any,limit:any,sort_by:any,sort_direction:any) => {
  return Http.get(`review/customer?page=${page}&limit=${limit}&search=${search}&sort_by=${sort_by}&sort_direction=${sort_direction}`);
};
export const getChefRatingReviewAPI = (search:any,page:any,limit:any,sort_by:any,sort_direction:any) => {
  return Http.get(`review/chef?page=${page}&limit=${limit}&search=${search}&sort_by=${sort_by}&sort_direction=${sort_direction}`);
};
export const ratingreviewdetailsAPI = (id:any) => {
  return Http.get(`review/details/${id}`);
};